import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { ICourseSession } from "src/app/attendanceRecord/interfaces/SessionsInterface";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { ICalendarCatalog } from "src/app/catalog/interfaces/catalog.interface";
import { SessionsService } from "src/app/services/session/sessions.service";

@Component({
  selector: "app-duplicate-attendance-modal",
  templateUrl: "./duplicate-attendance-modal.component.html",
  styleUrls: ["./duplicate-attendance-modal.component.css"],
})
export class DuplicateAttendanceModalComponent implements OnInit {
  @Input() sourceSession!: ICourseSession;
  @Input() yearList!: ICalendarCatalog[];
  @Input() selectedYear: number | null = null;

  @Output() confirm = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  // flags
  isLoadingSessions = false;

  // data
  public sessions: ICourseSession[] = [];
  public selectedTargetSession: ICourseSession | null = null;

  constructor(
    private authService: AuthenticationService,
    private sessionsService: SessionsService
  ) {}

  get sourceSessionName(): string {
    return this.sourceSession
      ? `${this.sourceSession.IdLocalizador} - ${this.sourceSession.titulo}`
      : "";
  }

  get isSameSession(): boolean {
    return this.sourceSession?.Id === this.selectedTargetSession?.Id;
  }

  onYearChange(yearId: number | null): void {
    this.selectedYear = yearId;
    this.selectedTargetSession = null;

    if (!yearId) {
      return;
    }

    this.loadCoursesSessions(yearId);
  }

  loadCoursesSessions(yearId: number) {
    const userId = this.authService.currentUserValue.id;
    this.isLoadingSessions = true;

    this.sessionsService
      .getCoursesSessionsByUserId(userId, { yearId })
      .subscribe({
        next: ({ data }) => {
          this.sessions = data.filter(
            session =>
              session.QrMeastro === this.sourceSession?.QrMeastro &&
              session.totalPartesReales ===
                this.sourceSession?.totalPartesReales &&
              session.Id !== this.sourceSession?.Id
          );

          this.isLoadingSessions = false;
        },
        error: () => {
          this.sessions = [];
          this.isLoadingSessions = false;
        },
      });
  }

  ngOnInit(): void {
    if (this.selectedYear) {
      this.onYearChange(this.selectedYear);
    }
  }

  onTargetSessionChange(sessionId: number | null): void {
    this.selectedTargetSession =
      this.sessions.find(s => s.Id === sessionId) ?? null;
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onConfirm(): void {
    if (!this.selectedTargetSession) {
      return;
    }

    this.confirm.emit(this.selectedTargetSession);
  }
}
